import { render } from "./FlexContent.vue?vue&type=template&id=e940e7f6"
import script from "./FlexContent.vue?vue&type=script&lang=js"
export * from "./FlexContent.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__